<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(owner, idx) in owners" :key="idx"
        class="pa-0 mb-2"
        cols=12
      >
        <v-card
          :elevation="0"
          outlined
          tile
        >
          <v-card-title>
          {{$t('owner')}} {{ idx + 1 }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              x-small
              @click="remove(idx)"
            >
              <v-icon
                class="mdi mdi-close"
              >
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols=4
                sm=3
              >
                <v-radio-group
                  v-model="owners[idx]['type']"
                  row
                  required
                >
                  <v-radio
                    v-for="option in ownerTypes"
                    :key='option.value'
                    :label="$t(option.text)"
                    :value="option.value"
                  />
                </v-radio-group>
              </v-col>
              <v-col>
                <v-checkbox
                  v-if="owners[idx]['type'] === 'person'"
                  v-model="owners[idx].owner_on_board"
                  :label="$t('owner_on_board')"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row align="center" v-if="owners[idx]['type'] === 'person'">
              <v-col
                cols=12
                sm=4
              >
                <v-text-field
                  :label="$t('given_names_&_surnames')"
                  v-model="owners[idx]['name']"
                />
              </v-col>

              <v-col
                cols=6
                sm="4"
              >
                <date-picker :label="$t('date_of_birth')" :picker="owners[idx]"></date-picker>
              </v-col>

              <v-col
                cols=6
                sm="4"
              >
                <v-select
                  :items="nationalities"
                  :label="$t('nationality')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="owners[idx]['nationality']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
                sm=4
              >
                <v-select
                  :items="documents"
                  :label="$t('document_type')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="owners[idx]['document_type']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
                sm=4
              >
                <v-text-field
                  :label="$t('document_number')"
                  v-model="owners[idx]['document_number']"
                />
              </v-col>

              <v-col
                v-if="owners[idx].owner_on_board"
                cols=12
                sm=4
              >
                <v-select
                  :items="ranks"
                  :label="$t('rank')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="owners[idx]['rank']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
              >
                <v-textarea
                  v-model="owners[idx]['details']"
                  outlined
                  rows=2
                  :label="$t('details')"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row align="center" v-if="owners[idx]['type'] === 'company'">
              <v-col
                cols=12
                sm=6
              >
                <v-text-field
                  :label="$t('name')"
                  v-model="owners[idx]['name']"
                />
              </v-col>

              <v-col
                cols=6
                sm=3
                >
                <v-select
                  :items="nationalities"
                  :label="$t('nationality')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="owners[idx]['nationality']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=6
                sm=3
                >
                <year-picker
                  :label="$t('year_formed')"
                  :picker="owners[idx].yearPicker"
                ></year-picker>
              </v-col>

              <v-col cols="12" sm="8" >
                <v-text-field
                  :label="$t('address')"
                  v-model="owners[idx]['address']"
                />
              </v-col>

              <v-col
                cols="12"
                sm="4"
                >
                <v-text-field
                  :label="$t('website')"
                  v-model="owners[idx]['website']"
                />
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        small
        :block="$vuetify.breakpoint.smAndDown"
        plain
        raised
        tile
        elevation="0"
        @click="addMore"
        >
        {{ $t('add_owner') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'
import DatePicker from '../ui/DatePicker.vue'
import YearPicker from '../ui/YearPicker.vue'
import { ExportUtils } from '../../services/DataExport'

export default {
  name: 'OwnerData',
  components: {
    DatePicker,
    YearPicker
  },
  data: vm => ({
    nationalities: maocData.dynamicLocalizedSelect('countries'),
    ranks: maocData.dynamicLocalizedSelect('ranks'),
    ownerTypes: maocData.asLocalizedSelect('ownerTypes'),
    documents: maocData.dynamicLocalizedSelect('documents'),
    owners: [vm.newOwnerObject()]
  }),
  methods: {
    newOwnerObject: function () {
      return {
        yearPicker: YearPicker.newPickerObject()
      }
    },
    addMore () {
      this.owners.push(this.newOwnerObject())
    },
    remove (idx) {
      this.owners.splice(idx, 1)
    },
    getData: function () {
      var data = []
      const vm = this
      this.owners.forEach(function (owner) {
        owner.year_formed = owner.yearPicker.year
        var newOwner = ExportUtils.copyObject(owner, ['menu', 'rawdate', 'yearPicker'])
        if (!ExportUtils.isObjectEmpty(newOwner)) {
          if (newOwner.nationality) {
            newOwner.nationality_en = vm.$t('countries.' + newOwner.nationality, 'en')
          }
          if (newOwner.document_type) {
            newOwner.document_type_en = vm.$t('documents.' + newOwner.document_type, 'en')
          }
          if (newOwner.rank) {
            newOwner.rank_en = vm.$t('all_ranks.' + newOwner.rank, 'en')
          }
          data.push(newOwner)
        }
      })
      return data
    },
    setData: function (data) {
      var component = this
      component.owners = []
      data.forEach(function (owner) {
        var newOwner = Object.assign(component.newOwnerObject(), owner)
        newOwner.yearPicker.year = newOwner.year_formed
        component.owners.push(newOwner)
      })
    }
  }
}
</script>
